import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
//ROUTE
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
//servicios
import {ClienteService} from 'src/app/services/cliente.service';
import {LoginService} from 'src/app/services/login.service';

@Component({
  selector: 'app-nav-bar-cliente',
  templateUrl: './nav-bar-cliente.component.html',
  styleUrls: ['./nav-bar-cliente.component.scss']
})
export class NavBarClienteComponent implements OnInit {
  public id?: any;
  public params?: any

  public basica: any 
  public userLogged: any
  public loading: any 

  constructor(private route: ActivatedRoute, private apollo: Apollo, private loginService:LoginService,
  private clienteService:ClienteService) {

    this.userLogged = this.loginService.getUserData()
    
   }

  ngOnInit(): void {
    this.getClienteById()
  }

  getClienteById(): void {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        /* console.log(data, errors) */
       this.basica = data.cliente?.xtensaBasica
        /* console.log(this.basica) */
        /* this.loading = loading  */
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

}
